import React from 'react';
import { CopyToClipboardButton } from '../../../../components/CopyToClipboardButton';
import { CodeBlock, Field, FieldGrid, SectionCard } from '../../../../components/Section';
import { IAlpacaOrder } from '../../../../types/alpaca';
import { stringifyJSON } from '../../../../utils/json';
import { round2Format, round4Format } from '../../../../utils/number';

interface AlpacaOrderProps {
  order: IAlpacaOrder;
}

export function AlpacaOrder({ order }: AlpacaOrderProps) {
  const error = stringifyJSON(order.error as any).toString();

  return (
    <SectionCard title="Order" sx={{ mt: '16px' }}>
      <FieldGrid columns={3}>
        <Field label="Id">
          <CopyToClipboardButton text={order.alpacaOrderId} value={order.alpacaOrderId} />
        </Field>
        <Field label="Step" value={order.step} />
        <Field label="Status" value={order.status?.name} />
        <Field label="Fund order id" value={order.fundOrderId} />
        <Field label="Actual amount" value={round2Format(order.alpacaActualAmount)} />
        <Field label="Actual price" value={round2Format(order.alpacaActualPrice)} />
        <Field label="Actual units" value={round4Format(order.alpacaActualUnits)} />
        <Field label="Account statement report" value={order.accountStatementReportCreated} />
        <Field label="Trade confirmation report" value={order.tradeConfirmationReportCreated} />
        {error && error !== 'null' && (
          <Field label="Error" fullWidth>
            <CodeBlock value={error} maxHeight={200} />
          </Field>
        )}
      </FieldGrid>
    </SectionCard>
  );
}
